module.exports = __webpack_public_path__ + "static/media/bg_main_screen_tablet_2-3.8290fc52.png";